import * as Yup from 'yup';

export const initialValues = {};

export const validationSchema = Yup.object().shape({});
